export function resolveRegistrationError(error: unknown): Record<string, string> {
  if (!(error instanceof Error)) {
    console.error(error);
    return {};
  }
  if (error.message.includes('already exists') && error.message.includes('email')) {
    return { email: 'An account with this email already exists' };
  }
  if (error.message.includes('already exists') && error.message.includes('username')) {
    return { username: 'This username is already taken' };
  }
  return { general: error.message || 'Registration failed. Please try again.' };
}
